import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(0);
  const buyers = [{
    name: 'Florencia B.',
    city: 'Córdoba',
    product: 'Pack Completo 🏆',
    time: '6 minutos'
  }, {
    name: 'Mariana L.',
    city: 'CABA',
    product: 'Pack Esencial 📘',
    time: '12 minutos'
  }, {
    name: 'Julieta S.',
    city: 'Rosario',
    product: 'Pack Completo 🏆',
    time: '24 minutos'
  }, {
    name: 'Carolina M.',
    city: 'Mendoza',
    product: 'Pack Esencial 📘',
    time: '41 minutos'
  }, {
    name: 'Lucía P.',
    city: 'Neuquén',
    product: 'Pack Completo 🏆',
    time: '1 hora'
  }];
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle logic
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentBuyer(prev => (prev + 1) % buyers.length);
        setIsVisible(true);
      }, 1000); // Wait 1s before showing next
      // Auto hide after 5s
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    }, 15000); // Every 15 seconds start a new cycle
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, [buyers.length]);
  return <AnimatePresence data-id="element-265">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto bg-navy-800 border border-navy-600 rounded-xl shadow-2xl p-4 pr-10 flex items-start gap-3" data-id="element-266">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-white transition-colors" data-id="element-267">
            <X className="w-4 h-4" data-id="element-268" />
          </button>

          <div className="mt-1 shrink-0" data-id="element-269">
            <CheckCircle className="w-5 h-5 text-green-400" data-id="element-270" />
          </div>

          <div data-id="element-271">
            <p className="text-xs text-green-400 font-semibold mb-1 uppercase tracking-wider" data-id="element-272">
              Compra verificada
            </p>
            <p className="text-sm text-white leading-tight" data-id="element-273">
              <span className="font-bold" data-id="element-274">{buyers[currentBuyer].name}</span> de{' '}
              {buyers[currentBuyer].city} compró <br data-id="element-275" />
              <span className="text-gold-400 font-medium" data-id="element-276">
                {buyers[currentBuyer].product}
              </span>
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-277">
              hace {buyers[currentBuyer].time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}